import Link from "next/link";
import Icon from "./Icon";

type RoomNavLinkProps = {
  href: string;
  label: string;
  direction: "left" | "right";
  rel?: "prev" | "next";
  ariaLabel?: string;
};

const navLinkClasses =
  "flex items-center gap-3 px-3 py-2 text-white/80 hover:text-white focus:text-white focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-transparent rounded transition-colors group";

export default function RoomNavLink({
  href,
  label,
  direction,
  rel,
  ariaLabel,
}: RoomNavLinkProps) {
  const marginClass = direction === "left" ? "-ml-3 -mt-2" : "-mr-3 -mt-2";
  const iconName = direction === "left" ? "chevron-left" : "chevron-right";

  return (
    <Link
      href={href}
      rel={rel}
      // Use label as aria-label to ensure they match (accessibility requirement)
      // Label is hidden on small screens (hidden sm:inline), so aria-label is needed
      // When label is visible, aria-label must match it exactly
      aria-label={ariaLabel || label}
      className={`${navLinkClasses} ${marginClass}`}
    >
      {direction === "left" && <Icon name={iconName} size="md" />}
      <span className="text-sm font-light hidden sm:inline">{label}</span>
      {direction === "right" && <Icon name={iconName} size="md" />}
    </Link>
  );
}

